import React, { FunctionComponent, useEffect } from 'react';
import { TextSmall } from 'components/chroma/extended/Text/TextSmall';
import { Message } from '@iag-packages/chroma-react/lib/components';
import styled from 'styled-components';
import {
  isDobInRange,
  isDobValid,
} from 'scenes/common/components/Questions/DateOfBirthQuestion/helper';

const Wrapper = styled.div`
  padding-top: 0.8rem;
  margin-bottom: -0.8rem;
`;

const getDobRangeValidationMessage = (
  entityType: string,
  value: string,
  minAge: number,
  maxAge: number
): string =>
  `The ${entityType} should be between the age ${minAge} and ${maxAge} (DD/MM/YYYY)`;

const DOBErrorMessage: FunctionComponent<{
  dobValue: string;
  entityType: string;
  minAge: number;
  maxAge: number;
  setError: Function;
}> = ({ dobValue, entityType, minAge, maxAge, setError }) => {
  const displayError =
    isDobValid(dobValue) && !isDobInRange(dobValue, minAge, maxAge);

  useEffect(() => {
    setError(displayError);
  }, [displayError, setError]);

  return (
    <>
      {displayError ? (
        <Wrapper>
          <Message error>
            <TextSmall color="red">
              {getDobRangeValidationMessage(
                entityType,
                dobValue,
                minAge,
                maxAge
              )}
            </TextSmall>
          </Message>
        </Wrapper>
      ) : null}
    </>
  );
};
export default DOBErrorMessage;
